import { render } from "./OngAvatar.vue?vue&type=template&id=052cf8b1&scoped=true"
import script from "./OngAvatar.vue?vue&type=script&lang=js"
export * from "./OngAvatar.vue?vue&type=script&lang=js"

import "./OngAvatar.vue?vue&type=style&index=0&id=052cf8b1&scoped=true&lang=css"

import exportComponent from "/var/www/transport/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052cf8b1"]])

export default __exports__